module.exports = __webpack_public_path__ + "img/room.5a8a6753.jpg";